import React from 'react';
import { CurrencyField, widthFormatter } from '../Formatters';

export const DEDUCTIBLE_COLS = [
    {
        dataField: 'name',
        isDummyColumn: true,
        headerAttrs: {
            hidden: true
        }
    },
    {
        dataField: 'total',
        isDummyColumn: true,
        align: 'right',
        footerStyle: widthFormatter('totalCol'),
        style: widthFormatter('totalCol'),
        hidden: true
    }
];
